var _excluded = ["as", "children", "variant", "subStyle", "color", "align", "transform", "extend"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef, useContext } from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import TextContext from './TextContext.js';
function stripFlowElement(el) {
  return /^(div|p|h[1-6])$/.test(el) ? 'span' : el;
}
var defaultVariant = 'spruce';
var defaultSubStyle = 'standard';
var defaultColor = 'foreground.primary';
var Text = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'div' : _ref$as,
    children = _ref.children,
    variant = _ref.variant,
    subStyle = _ref.subStyle,
    color = _ref.color,
    align = _ref.align,
    transform = _ref.transform,
    extend = _ref.extend,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useFela = useFela(),
    css = _useFela.css;
  var _useContext = useContext(TextContext),
    isRootElement = _useContext.isRootElement,
    parentVariant = _useContext.parentVariant,
    parentSubStyle = _useContext.parentSubStyle,
    parentColor = _useContext.parentColor;
  var appliedVariant = variant || parentVariant || defaultVariant;
  var appliedSubStyle = subStyle || parentSubStyle || defaultSubStyle;
  var appliedColor = color || parentColor || defaultColor;
  var style = {
    margin: 0,
    display: isRootElement ? 'block' : undefined,
    typographyVariant: appliedVariant,
    typographySubStyle: appliedSubStyle,
    color: appliedColor,
    textAlign: align,
    textTransform: transform
  };
  var Component = isRootElement ? as : stripFlowElement(as);
  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref
  }, props, {
    className: css(style, extend)
  }), /*#__PURE__*/React.createElement(TextContext.Provider, {
    value: {
      isRootElement: false,
      parentVariant: appliedVariant,
      parentSubStyle: appliedSubStyle,
      parentColor: appliedColor
    }
  }, children));
});
export default Text;
Text.displayName = 'Text';
Text.propTypes = {
  /** Sets the font variants */
  variant: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  /** Sets the font variant substyle */
  subStyle: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  /** Sets the font color */
  color: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  /** Sets the text-align */
  align: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  /** Sets the text-transform */
  transform: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  /** Any valid React element, function, or a string specifying a name for an HTML element */
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.elementType, PropTypes.func]),
  /** A JSX node */
  children: PropTypes.node,
  /** Additional styles, use with caution */
  extend: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.array])
};